export class Connection {
    public connectionId!: string
    public connectionName!: string
    public appScope!: string
    public subscriptionKey!: string
    public useMSI!: number
}